import { Component, OnInit, ViewChild } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { GlobalService } from '../../shared/services/global/global.service';
import { LeadInformationComponent } from './lead-information/lead-information.component';
import { LeadDetailsComponent } from './visa-lead-details/lead-details.component';
import { ImportantInformationComponent } from './important-information/important-information.component';
import { DocumentCollectionComponent } from './document-collection/document-collection.component';
import { LeadsService } from 'src/app/business-service/leads/leads.service';
import { VisaService } from 'src/app/business-service/visa/visa.service';
import { ModalsService } from '../../shared/services/modals/modals.service';

@Component({
  selector: 'app-visa-form',
  templateUrl: './visa-form.component.html',
  styleUrls: ['./visa-form.component.scss'],
})
export class VisaFormComponent implements OnInit {

  @ViewChild(LeadInformationComponent) leadInformationComponent!: LeadInformationComponent;
  @ViewChild(LeadDetailsComponent) leadDetailsComponent!: LeadDetailsComponent;
  @ViewChild(ImportantInformationComponent) importantInformationComponent!: ImportantInformationComponent;
  @ViewChild(DocumentCollectionComponent) documentCollectionComponent!: DocumentCollectionComponent;

  visaId: any;
  leadId: any;
  editVisaId: any;

  visaDetails: any;

  leadInformation: any;
  leadDetailsFormData: any;
  importantInformationFormData: any;
  documentCollectionFormData: any;

  orderOfTabs: string[] = ['lead', 'details', 'important', 'documents'];
  orderOfTabsIndex: number = 1;
  componentView: string = this.orderOfTabs[this.orderOfTabsIndex];

  constructor(
    private _modalController: ModalController,
    private _globalService: GlobalService,
    private _leadService: LeadsService,
    private _visaService: VisaService,
    private _modalService: ModalsService
  ) { }

  ngOnInit() {
    if (this.leadId) {
      this._leadService.getLead(this.leadId).subscribe((data) => {
        this.leadInformation = data;
        this.leadInformation.dataSaved = true;
      })
    }

    if (this.editVisaId) {
      this._visaService.getVisa(this.editVisaId).subscribe((data) => {
        this.visaDetails = data;
        if (this.visaDetails) {
          this.assignVisaDetailsTabs();
          this.assignVisaId(this.leadDetailsFormData.visaId);
        }
      })
    }
  }

  closeModal() {
    this._modalController.dismiss();
  }

  assignVisaDetailsTabs(){
    this.leadDetailsFormData = this.visaDetails.visaLeadInfo ? 
    { ...this.leadDetailsFormData , ...this.visaDetails.visaLeadInfo}: null;

    this.importantInformationFormData = this.visaDetails.importantInformation? 
    {...this.importantInformationFormData,...this.visaDetails.importantInformation}: null;

    this.documentCollectionFormData = this.visaDetails.visaDocuments? 
    {...this.documentCollectionFormData, ...this.visaDetails.visaDocuments}: null;

    this.makeAvalibleTabsGreen();
  }

  makeAvalibleTabsGreen(){
    if(this.leadDetailsFormData){
      this.leadDetailsFormData.dataSaved = true;
    }
    if(this.importantInformationFormData){
      this.importantInformationFormData.dataSaved = true;
    }
    if(this.documentCollectionFormData){
      this.documentCollectionFormData.dataSaved = true;
    }
  }


  async onViewChangeFromTab(view: string) {
    if (this.checkCurrentFormDirty(this.componentView)) {
      let res = await this._globalService.confirmTabChangeAction("You have unsaved data, do you want to Proceed?", "Unsaved Data / Invalid Form", "Save & Proceed", "Proceed")
      switch (res) {
        case 'saveProceed': {
          if(await this.saveDataOfCurrentForm(this.componentView)){
            this.changeComponentView(view);
          }else{
          }
          break
        }
        case 'proceed': {
          this.changeComponentView(view);
          break;
        }
      }
    } else {
      this.changeComponentView(view);
    }
  }

  changeComponentView(view: any) {
    this.componentView = view;
    this.orderOfTabsIndex = this.orderOfTabs.indexOf(view);
  }

  reloadAllChildComponents() {
    if (this.leadDetailsComponent) {
      this.leadDetailsComponent.ngOnInit();
    }
    if (this.importantInformationComponent) {
      this.importantInformationComponent.ngOnInit();
    }
    if (this.documentCollectionComponent) {
      this.documentCollectionComponent.ngOnInit();
    }
  }

  async onViewChange(goPrevious: any) {
    if (goPrevious) {
      this.orderOfTabsIndex--;
      this.componentView = this.orderOfTabs[this.orderOfTabsIndex];
    } else {
      this.orderOfTabsIndex++;
      this.componentView = this.orderOfTabs[this.orderOfTabsIndex];
    }
  }

  checkCurrentFormDirty(view: any): any {
    switch (view) {
      case 'lead': {
        return (this.leadInformationComponent?.formDataModified());
      }
      case 'details': {
        return (this.leadDetailsComponent?.formDataModified());
      }
      case 'important': {
        return (this.importantInformationComponent?.formDataModified());
      };
      case 'documents': {
        return (this.documentCollectionComponent?.formDataModified());
      };
      default: {
        return false;
      }
    }
  }

  async saveDataOfCurrentForm(view: any) {
    switch (view) {
      case 'lead': {
        return (this.leadInformationComponent?.onSubmit());
      }
      case 'details': {
        return (this.leadDetailsComponent?.onSubmit());
      }
      case 'important': {
        return (this.importantInformationComponent?.onSubmit());
      };
      case 'documents': {
        return (this.documentCollectionComponent?.onSubmit());
      };
      default: {
        return false;
      }
    }
  }

  assignVisaId(id: any) {
    this.visaId = id;
  }
  storeLeadInformation(formData: any) {
    this.leadInformation = {
      ...formData,
      dataSaved: true,
      dataInvalid: false
    }
  }
  storeLeadDetailsData(formData: any) {
    this.leadDetailsFormData = {
      ...formData,
      dataSaved: true,
      dataInvalid: false
    }
  }
  storeImportantInformationData(formData: any) {
    this.importantInformationFormData = {
      ...formData,
      dataSaved: true,
      dataInvalid: false
    }
  }
  storeDocumentsData(formData: any) {
    this.documentCollectionFormData = {
      ...formData,
      dataSaved: true,
      dataInvalid: false
    }
  }

  async openReviewScreen(){
    if (this.checkCurrentFormDirty(this.componentView)) {
      let res = await this._globalService.confirmTabChangeAction("You have unsaved data, do you want to Proceed?", "Unsaved Data / Invalid Form", "Save & Proceed", "Proceed")
      switch (res) {
        case 'saveProceed': {
          if(await this.saveDataOfCurrentForm(this.componentView)){
            this.openVisaReviewModal();
          }else{
          }
          break
        }
        case 'proceed': {
          this.openVisaReviewModal();
          break;
        }
      }
    } else {
      this.openVisaReviewModal();
    }
  }

  async openVisaReviewModal(){
    await this._modalService.closeAllModals();
    this._modalService.openVisaReviewScreen(this.visaId);
  }
}

